import { Component, OnInit } from '@angular/core';
import { ContractDto } from 'src/app/models/contractDto';
import { ContractsService } from 'src/app/services/contracts.service';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationType } from 'src/app/models/notification.message';
import { approveContractVm } from 'src/app/models/approveContractVm';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TokenService } from 'src/app/services/token.service';
import { RequestApprovalDto } from 'src/app/models/requestapproval-dto';
import { RequestApprovalsService } from 'src/app/services/requestapprovals.service';
import { approveContractAxiom } from 'src/app/models/approveContractAxiom';

@Component({
  selector: 'app-view-approvedcontract',
  templateUrl: './view-approvedcontract.component.html',
  styleUrls: ['./view-approvedcontract.component.css']
})
export class ViewApprovedcontractComponent implements OnInit {

  ViewRequestVisible = false;
  ApproveRequest: ContractDto | any
  RequestApprovals: RequestApprovalDto[] | undefined;
  currentUser: any
  approvedContract: ContractDto[] | any;
  showCreatedByColumn: boolean = false;
  showFunctionColumn: boolean = false;

  constructor(private contractService: ContractsService, private notification: NotificationService,
    private tokenService: TokenService, private requestApprovalService:RequestApprovalsService  ) { }

  Contracts: ContractDto[] | undefined;
  Comment: string = '';
  ngOnInit(): void {
    this.loadRecords();

  }


  async loadRecords() {
    ;
    let resContracts = await this.contractService.getPendingContracts().toPromise();
    this.Contracts = <ContractDto[]>resContracts.responseData;

    let resApprovedContracts = await this.contractService.MyApprovedLabourRequests().toPromise();
    ;
    this.approvedContract = <ContractDto[]>resApprovedContracts.responseData;
    
    this.currentUser = this.tokenService.getInfo();

    // if (!(this.Contracts[0].createdBy == this.currentUser.profile.email)) { this.showCreatedByColumn = true; }
    // if (!(this.Contracts[0].departmentName == this.currentUser.profile.departmentName)) { this.showFunctionColumn = true; }

 
  }
  // async approveContract() {

  
  //     const model: approveContractAxiom = { id: this.ApproveRequest.id, message: this.Comment , token:'', axiomId: 0};

  //     this.contractService.approveContract(model).subscribe({
  //       next: (data => {
  //         
  //         if (data.responseCode == "00") {
  //           this.notification.sendMessage({
  //             message: data.message,
  //             type: NotificationType.success
  //           });

  //           this.loadRecords();
  //           this.close()
  //         }
  //         else {

  //           this.notification.sendMessage({
  //             message: data.message,
  //             type: NotificationType.error
  //           });

  //         }

  //       }),
  //       error: ((error: any) => {
  //         console.log(error.error);
  //         ;


  //         this.notification.sendMessage({
  //           message: error.error.message,
  //           type: NotificationType.error
  //         });
  //       })

  //     });

  // }

  // async rejectContract() {

  //   if (this.Comment === '') {
  //     this.notification.sendMessage({
  //       message: 'Comment is required when rejecting request',
  //       type: NotificationType.error
  //     });
  //   }
  //   else {
      

  //       this.close();

  //       const model: approveContractVm = { id: this.ApproveRequest.id, message: this.Comment , token:''};

  //       this.contractService.rejectContract(model).subscribe({
  //         next: (data => {

  //           if (data.responseCode == "00") {
  //             this.notification.sendMessage({
  //               message: data.message,
  //               type: NotificationType.success
  //             });

  //             this.loadRecords();
  //             this.close();
  //           }
  //           else {

  //             this.notification.sendMessage({
  //               message: data.message,
  //               type: NotificationType.error
  //             });

  //           }

  //         }),
  //         error: ((error: any) => {
  //           console.log(error.error);
  //           ;


  //           this.notification.sendMessage({
  //             message: error.error.message,
  //             type: NotificationType.error
  //           });
  //         })

  //       });
    
  //   }
  // }


  async open(data: ContractDto) {

    this.ViewRequestVisible = true;

    this.ApproveRequest = data;
    let resApprovals = await this.requestApprovalService.getRequestApprovals(data.id).toPromise();
    this.RequestApprovals = <RequestApprovalDto[]>resApprovals.responseData;

  }

  close(): void {
    this.ViewRequestVisible = false;
  }

  cancel(): void {
 return;
  }
 
  confirm(): void {
    alert('click confirm');
  }



}
